import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Button, Modal } from "antd";
import {
  getExecutiveEmployeeList,
  markAsDelete,
  selectedRow,
} from "../../actionCreator/leadListingActionCreater";
import { useAlert } from "../../context/AlertProvider";

const DeleteLead = ({ isOpen, handleCancel, data, isMulti }) => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [searchParams] = useSearchParams();

  const handleDelete = async () => {
    const res = await dispatch(
      markAsDelete({
        clientLeads: isMulti
          ? data?.map((d) => ({ id: d?.key, status: 19 }))
          : [{ id: data?.id, status: 19 }],
      }),
    );
    if (res?.status === 200) {
      showAlert(
        "success",
        isMulti
          ? "Leads have been successfully marked as deleted."
          : "Lead has been successfully marked as deleted.",
      );
      const allParams = {};
      for (const [key, value] of searchParams.entries()) {
        allParams[key] = value;
      }

      dispatch(
        getExecutiveEmployeeList({
          ...allParams,
          page: allParams?.page ? allParams?.page - 1 : 0,
        }),
      );
      dispatch(selectedRow([]));
    } else {
      showAlert("error", res?.response?.data?.title);
    }
  };

  const isDeleted = isMulti
    ? data?.filter((d) => d?.executiveData?.status === 19)
    : 0;
  const isDeleteAllowed = isMulti
    ? data
        ?.filter((d) => d?.executiveData?.status !== 19)
        ?.filter((d) => {
          return d?.executiveData?.allowedActions?.includes("EDIT");
        })
    : 0;
  const allowCount = isMulti ? isDeleteAllowed?.length : 0;
  const deletedCount = isMulti ? isDeleted?.length : 0;
  const notAllowed = isMulti
    ? data
        ?.filter((d) => d?.executiveData?.status !== 19)
        ?.filter((d) => {
          return !d?.executiveData?.allowedActions?.includes("EDIT");
        })?.length
    : 0;

  return (
    <Modal
      title={null}
      closable
      centered
      className="delete-popup"
      open={isOpen}
      onCancel={handleCancel}
      footer={[]}
    >
      <div className="tw-bg-slate-50 tw-text-slate-800 tw-text-lg tw-font-bold tw-py-4 tw-px-6 tw-rounded-t-2xl tw-border tw-border-solid tw-border-slate-100/50">
        Mark as Delete
      </div>
      <div className="tw-p-6 tw-text-slate-700 tw-text-sm">
        {isMulti
          ? deletedCount === data?.length
            ? "All selected leads have already been marked as deleted."
            : allowCount !== data?.length
              ? deletedCount && !notAllowed
                ? `Out of the ${data?.length} selected leads, ${deletedCount} are already marked as deleted. Do you want to mark the other ${allowCount} as deleted?`
                : deletedCount && notAllowed
                  ? !allowCount
                    ? `Out of the ${data?.length} selected leads, ${deletedCount} are already marked as deleted and you don’t have permission to edit ${notAllowed} of them.`
                    : `Out of the ${data?.length} selected leads, ${deletedCount} are already marked as deleted and you don’t have permission to edit ${notAllowed} of them. Do you want to mark the remaining ${allowCount} as deleted?`
                  : !deletedCount && notAllowed
                    ? !allowCount
                      ? `You don’t have permission to edit ${notAllowed} selected leads.`
                      : `Out of the ${data?.length} selected leads, you don’t have permission to edit ${notAllowed} of them. Do you want to delete the remaining ${allowCount}?`
                    : "Are you sure you want to mark selected items as deleted?"
              : "Are you sure you want to mark selected items as deleted?"
          : "Are you sure you want to mark this item as deleted?"}
      </div>
      <div className="tw-flex tw-bg-slate-50 tw-rounded-b-2xl tw-py-4 tw-px-6 tw-items-center tw-justify-end tw-gap-3 tw-border tw-border-solid tw-border-slate-100/50">
        <Button
          className="!tw-h-[38px] !tw-rounded-lg !tw-border-slate-200 !tw-bg-white !tw-px-5 !tw-text-sm !tw-font-bold !tw-text-slate-500 hover:!tw-border-slate-300 hover:!tw-text-slate-700 tw-transition-all tw-duration-200"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        {((isMulti && !!allowCount && deletedCount !== data?.length) ||
          !isMulti) && (
          <Button
            type="primary"
            className="theme-btn !tw-h-[38px] !tw-rounded-lg !tw-text-white tw-text-sm tw-font-bold tw-px-5 tw-shadow-[0_4px_12px_rgba(93,68,255,0.15)] hover:tw-shadow-[0_6px_16px_rgba(93,68,255,0.25)] hover:tw-scale-[1.01] tw-transition-all tw-duration-200"
            onClick={() => {
              handleDelete();
              handleCancel();
            }}
          >
            Mark as Deleted
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default DeleteLead;
